import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { I18nModule } from './core/i18n';
import { TranslateLoaderFactory } from './translate-loader.factory';
import { BrandService } from './core/brand';
import { BrandModule } from './core/brand/brand.module';
import { PsButtonModule } from '@paysafe-ui/components/button';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { AuthInterceptor } from './shared/services/auth.interceptor';
import { PS_DATE_LOCALE, PsNativeDateModule } from '@paysafe-ui/components/core';
import { PsDatepickerModule } from '@paysafe-ui/components/datepicker';
import { PsDialogRef } from '@paysafe-ui/components/dialog';
import { DatePipe } from '@angular/common';
import { PsProgressSpinnerModule } from '@paysafe-ui/components/progress-spinner';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    HttpClientModule,
    SharedModule,
    BrandModule,
    I18nModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory,
        deps: [BrandService]
      }
    }),
    PsButtonModule,
    PsDatepickerModule,
    PsNativeDateModule,
    PsProgressSpinnerModule,
    HttpClientXsrfModule
  ],
  providers: [
    DatePipe,
    {
      provide: 'Window',
      useValue: window
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: PS_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: PsDialogRef,
      useValue: {
        close: (dialogResult: any) => {},
        afterClosed: (dialogResult: any) => {}
      }
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
